import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import Loader from "../../../core/common/loader";
import api from "../../../services/api";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { showBasicAlert } from "../../../core/common/useAlert";
import DeleteModal from "../../../core/modals/deleteModal";
import { useSelector } from "react-redux";
import axios from "axios";

import EditCompany from "./edit_company_modal";
type PasswordField = "password" | "confirmPassword";

const CompaniesList = () => {
  const location = useLocation();
  const signature = localStorage.getItem("signature");
  const [imagePreview, setImagePreview] = useState<any | null>(null);

  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };

  const initialFormData = {
    companyName: "",
    email: "",
    countryCode: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    address1: "",
    address2: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    logo: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [isLoading, setIsLoading] = useState(false); // state to track loading

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //Country Data and Function Start
  const [CountryCode, setCountryCode] = useState<any[]>([]);
  const handleCountryCodeChange = (e: any) => {
    const country_code = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      countryCode: country_code,
    }));
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const generateRandomPassword = () => {
    const length = 12; // Desired length of the password
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let randomPassword = "";
    for (let i = 0; i < length; i++) {
      randomPassword += charset.charAt(
        Math.floor(Math.random() * charset.length)
      );
    }
    setFormData({ ...formData, password: randomPassword });
  };

  const [countries, setCountries] = useState<any[]>([]);

  const [statesOrignal, setStatesOrignal] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);

  const [citiesOrignal, setCitiesOrignal] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);

  const user = useSelector((state: any) => state.user.user);

  const handleCountryChange = (e: any) => {
    const countryId = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      country: countryId,
      state: "", // Reset state
      city: "", // Reset city
    }));
    // Filter states based on country selection
    const filteredStates = statesOrignal.filter(
      (state) => state.country_id == countryId
    );
    setStates(filteredStates);
  };

  const handleStateChange = (e: any) => {
    const stateId = e.target.value;
    // Filter cities based on state selection
    setFormData((prevData) => ({
      ...prevData,
      state: stateId,
      city: "", // Reset city when state changes
    }));

    const filteredCities = citiesOrignal.filter(
      (city) => city.state_id == stateId
    );
    setCities(filteredCities);
  };

  const handleCityChange = (e: any) => {
    const cityId = e.target.value;
    // Filter cities based on state selection
    setFormData((prevData) => ({
      ...prevData,
      city: cityId, // Reset city when state changes
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      companyName: formData.companyName,
      email: formData.email,
      phone_code: formData.countryCode,
      mobile_no: formData.phoneNumber,
      password: formData.password,
      address1: formData.address1,
      address2: formData.address2,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode,
      logo: formData.logo,
    };
    try {
      setIsLoading(true);
      const response = await api.post(
        "userService/addNewChildCompany",
        dataToSend
      );
      if (response.data.message[0].status) {
        setFormData(initialFormData);
        document.getElementById("close-company-add-form")?.click();
      }
      await updateUI();
      setIsLoading(false); // hide loader after response
      showBasicAlert(response.data.message[0].msg);
      //Send email to customer about login details
    } catch (error: any) {
      setIsLoading(false); // hide loader after response
      showBasicAlert(error.data.message[0].msg);
      console.error("Error submitting data", error);
    }
  };

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);

  const updateUI = async () => {
    try {
      const [complanyList] = await Promise.all([
        api.post("userService/getChildCompanyList", { signature }),
      ]);
      setData(complanyList.data.data.data);
      setFilteredData(complanyList.data.data.data);

      return;
    } catch (err: any) {
      showBasicAlert(err.data.message[0].msg);
    }
  };

  //Exort Data Handle function Start
  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Example columns
    const columns = ["Company Name", "Email", "Phone", "Location", "Status"];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.key, // Assuming the first element is a number (ID)
      item.Company_Name, // Assuming the second element is a string (Company name)
      item.Email, // Email (string)
      item.Phone, // Plan (string)
      item.Location, // Date (string)
      item.Status, // Status (string)
    ]);
    // Generate the table in the PDF (no need to pass `doc` as the first argument anymore)
    doc.autoTable({
      head: [columns],
      body: tableData,
    });

    // Save the PDF
    doc.save("CompaniesList.pdf");
  };
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convert JSON to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "CompaniesList.xlsx");
  };
  //Exort Data Handle function End

  //Filters Start
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (statusFilter && item.Status !== statusFilter) {
            return false;
          }

          // Apply date range filter (if dates are selected)
          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.CreatedDate);

            // Convert moment objects to Date objects if needed
            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            // Check if the created date is within the selected date range
            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending":
              return a.Company_Name.localeCompare(b.Company_Name);
            case "Descending":
              return b.Company_Name.localeCompare(a.Company_Name);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= oneMonthAgo &&
                new Date(a.CreatedDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last 7 days, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= sevenDaysAgo &&
                new Date(a.CreatedDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          setFilteredData([]);
        }
      }
    }
  }, [statusFilter, sortBy, selectedStartDate, selectedEndDate]);

  const handleReset = () => {
    setFilteredData(data);
    setStatusFilter("");
    setSortBy("Last 7 Days");
  };

  //Filters End

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        setIsLoading(true);
        const [countryResponse, stateResponse] = await Promise.all([
          api.post("userService/getCountry", { signature }),
          api.post("userService/getState", { signature }),
        ]);
        setCountryCode(countryResponse.data.data);
        setCountries(countryResponse.data.data);
        setStatesOrignal(stateResponse.data.data);
        await updateUI();
        setIsLoading(false);

        var cityResponse = await api.post("userService/getCity", { signature });
        setCitiesOrignal(cityResponse.data.data);
      } catch (err: any) {
        showBasicAlert(err.data.message[0].msg);
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  //Edit company start

  //Update Company End
  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);
  //Delete Company Start

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post("userService/deleteChildCompany", {
            signature,
            id,
          });
          await updateUI();
          setIsLoading(false); // hide loader after response
          showBasicAlert(response.data.message[0].msg);
        } catch (error: any) {
          setIsLoading(false); // hide loader after response
          showBasicAlert(error.data.message[0].msg);
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };
  //Delete Compamny End

  const [modalData, setModalData] = useState(null);

  const handleEditOpenModal = (record: any) => {
    if (
      citiesOrignal.length === 0 ||
      statesOrignal.length == 0 ||
      countries.length == 0
    ) {
      console.warn("Cities data is not loaded yet.");
      return;
    }
    var Country =
      countries.find((item: any) => item.id == record.Country)?.name ||
      record.Country;
    var State =
      statesOrignal.find((item: any) => item.id == record.State)?.name ||
      record.State;
    var City =
      citiesOrignal.find((item: any) => item.id == record.City)?.name ||
      record.City;
    record.signature = signature;
    record.Country = Country;
    record.State = State;
    record.City = City;
    setModalData(record);
  };

  const defaultCompanyData = {
    Address1: "",
    Address2: "",
    City: "",
    Company_Name: "",
    Country: "",
    CreatedDate: "",
    Email: "",
    Facebook: "",
    Image: "",
    Image2: "",
    Instagram: "",
    Phone: "",
    Pincode: "",
    State: "",
    Status: "",
    Twitter: "",
    Website: "",
    phone_code: "",
    signature: "",
    countries: [],
    statesOrignal: [],
    citiesOrignal: [],
    Linkedin: "",
    Location: "",
    Whatsapp: "",
    key: "",
    Password: "",
    logo: "",
  };

  //Edit company end

  const routes = all_routes;

  const columns = [
    {
      title: "Company Name",
      dataIndex: "Company_Name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          {record.Image ? (
            <Link
              to={`${routes.companiesDetails.replace(":id", record.key)}${
                location?.search
              }`}
              className="avatar avatar-md border rounded-circle overflow-hidden">
              <ImageWithBasePath
                src={record.Image}
                className="img-fluid"
                alt="img"
              />
            </Link>
          ) : (
            <Link
              to={`${routes.companiesDetails.replace(":id", record.key)}${
                location?.search
              }`}
              className="avatar avatar-md bg-primary text-white d-flex align-items-center justify-content-center rounded-circle fw-bold text-uppercase"
              style={{ width: 40, height: 40 }}>
              {text?.charAt(0)}
            </Link>
          )}
          <div className="ms-2">
            <h6 className="fw-medium mb-0">
              <Link
                to={`${routes.companiesDetails.replace(":id", record.key)}${
                  location?.search
                }`}>
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Company_Name.length - b.Company_Name.length,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => a.Email.length - b.Email.length,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: any, b: any) => a.Phone.length - b.Phone.length,
    },
    {
      title: "Location",
      dataIndex: "Location",
      sorter: (a: any, b: any) => a.Location.length - b.Location.length,
    },
    {
      title: "Contact",
      dataIndex: "",
      render: () => (
        <ul className="contact-icon d-flex align-items-center ">
          <li>
            <Link
              to="#"
              className="p-1 rounded-circle contact-icon-mail d-flex align-items-center justify-content-center"
              onClick={(e: any) => {
                e.preventDefault();
                showBasicAlert("Coming soon");
              }}>
              <span className="d-flex align-items-center justify-content-center">
                <i className="ti ti-mail text-gray-5"></i>
              </span>
            </Link>
          </li>
          <li>
            <Link
              to="#"
              className="p-1 rounded-circle contact-icon-call d-flex align-items-center justify-content-center"
              onClick={(e: any) => {
                e.preventDefault();
                showBasicAlert("Coming soon");
              }}>
              <span className="d-flex align-items-center justify-content-center">
                <i className="ti ti-phone-call text-gray-5"></i>
              </span>
            </Link>
          </li>
        </ul>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <>
          <span
            className={`badge d-inline-flex align-items-center badge-xs ${
              text === "Active" ? "badge-success" : "badge-danger"
            }`}>
            <i className="ti ti-point-filled me-1"></i>
            {text}
          </span>
        </>
      ),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },

    {
      title: "",
      dataIndex: "actions",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to={`${routes.companiesDetails.replace(":id", record.key)}${
              location?.search
            }`}
            className="me-2"
            title="View">
            <i className="ti ti-eye" />
          </Link>
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_company"
            onClick={(e: any) => {
              e.preventDefault();
              handleEditOpenModal(record);
            }}
            title="Edit">
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            onClick={(e: any) => {
              e.preventDefault();
              setDeleteRecord(record);
            }}
            title="Delete">
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  const uploadFileToCloudinary = async (file: File) => {
    const UPLOAD_PRESET: any = process.env.REACT_APP_UPLOAD_PRESET;
    const CLOUDINARY_URL = `${process.env.REACT_APP_API_CLOUDNIRY_URL}/${process.env.REACT_APP_CLOUD_NAME}/upload`;
    const FOLDER_PATH = "cms/profile_pic/" + user?.userDetails.id;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);
    formData.append("folder", FOLDER_PATH);

    try {
      const response = await axios.post(CLOUDINARY_URL, formData);
      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      showBasicAlert("Failed to upload file. Please try again.");
      return null;
    }
  };

  const handleFileChange = async (e: any) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile || !selectedFile.type.startsWith("image/")) {
      showBasicAlert("Please select a valid image file.");
      return;
    }

    // Set uploading state
    setIsUploadingImage(true);

    const result = await uploadFileToCloudinary(selectedFile);

    if (result?.secure_url) {
      setIsImageLoading(true);
      setImagePreview({
        preview: result.secure_url,
        data: result.secure_url,
      });

      setFormData((prev: any) => ({
        ...prev,
        logo: result.secure_url,
      }));
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    // Reset uploading state
    setIsUploadingImage(false);
  };
  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const handleImageError = () => {
    setIsImageLoading(false);
    showBasicAlert("Failed to load image. Please try again.");
  };

  const emojiFromUPlus = (val?: string) => {
    if (!val) return "";
    // pick all U+XXXXXX tokens, fallback to split by non-hex
    const tokens =
      val.match(/U\+[0-9A-F]{4,6}/gi)?.map((t) => t.slice(2)) ||
      val
        .replace(/U\+/gi, "")
        .split(/[^0-9A-F]+/i)
        .filter(Boolean);

    return String.fromCodePoint(...tokens.map((h) => parseInt(h, 16)));
  };

  const resetForm = (): void => {
    // Reset form data to initial state
    setFormData({
      companyName: "",
      email: "",
      countryCode: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      address1: "",
      address2: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
      logo: "",
    });

    // Reset image preview - use null instead of empty object
    setImagePreview({
      preview: "",
      data: "",
    });

    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    // Reset password visibility
    setPasswordVisibility({
      password: false,
      confirmPassword: false,
    });

    // Reset location-dependent states
    setStates([]);
    setCities([]);

    setImagePreview({
      preview: "",
      data: "",
    });
  };
  return (
    <>
      {isLoading && <Loader />}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Companies</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">CRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Companies List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={`${routes.companiesList}${location?.search}`}
                    className="btn btn-icon btn-sm active bg-primary text-white me-1"
                    title="List">
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={`${routes.companiesGrid}${location?.search}`}
                    className="btn btn-icon btn-sm"
                    title="Grid">
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                {/* <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={handleExportPDF}
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={handleExportExcel}
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div> */}
                <div className="mb-2">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    data-bs-toggle="modal"
                    data-bs-target="#add_company"
                    className="btn btn-primary d-flex align-items-center">
                    <i className="ti ti-circle-plus me-2" />
                    Add Company
                  </Link>
                </div>
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Companies List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRanges onDateChange={handleDateChange} />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>

                <div className="dropdown me-3">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown">
                    Status {statusFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setStatusFilter("Active");
                        }}>
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setStatusFilter("Inactive");
                        }}>
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown">
                    Sort By: {sortBy}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Recently Added");
                        }}>
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Ascending");
                        }}>
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Descending");
                        }}>
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Last Month");
                        }}>
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Last 7 Days");
                        }}>
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleReset}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={JSON.stringify(filteredData)}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => e.preventDefault()}
              className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      {/* Add Company */}
      <div className="modal fade" id="add_company">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add New Company</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetForm}>
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body pb-0">
                <div className="col-md-12">
                  <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                    <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames position-relative">
                      {isImageLoading && (
                        <div className="position-absolute top-50 start-50 translate-middle">
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status">
                            <span className="visually-hidden">
                              Loading image...
                            </span>
                          </div>
                        </div>
                      )}
                      <img
                        src={
                          imagePreview?.preview || "assets/img/users/user.png"
                        }
                        alt="Profile preview"
                        className="rounded-circle"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          opacity: isImageLoading ? 0.5 : 1,
                        }}
                        onLoad={handleImageLoad}
                        onError={handleImageError}
                      />
                    </div>
                    <div className="profile-upload">
                      <div className="mb-2">
                        <h6 className="mb-1">Upload Profile Image</h6>
                        <p className="fs-12">Image should be below 4 mb</p>
                      </div>
                      <div className="profile-uploader d-flex align-items-center">
                        <div
                          className={`drag-upload-btn btn btn-sm btn-primary me-2 ${
                            isUploadingImage ? "uploading" : ""
                          }`}>
                          {isUploadingImage ? (
                            <>
                              <div
                                className="spinner-border spinner-border-sm text-white me-1"
                                role="status">
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              Uploading...
                            </>
                          ) : (
                            "Upload"
                          )}
                          <input
                            ref={fileInputRef}
                            name="file"
                            type="file"
                            accept="image/*"
                            className="form-control image-sign"
                            onChange={handleFileChange}
                            disabled={isUploadingImage}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              opacity: 0,
                              cursor: isUploadingImage
                                ? "not-allowed"
                                : "pointer",
                            }}
                          />
                        </div>
                        {imagePreview && !isUploadingImage && (
                          <Link
                            to="#"
                            className="btn btn-light btn-sm"
                            onClick={(e: any) => {
                              e.preventDefault();
                              setImagePreview({
                                preview: "",
                                data: "",
                              });
                              if (fileInputRef.current) {
                                fileInputRef.current.value = "";
                              }
                            }}>
                            Cancel
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* Company Name */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Company Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Email Address */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Country Code */}
                  <div className="col-md-2">
                    <div className="mb-3">
                      <label className="form-label">
                        Country Code <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleCountryCodeChange}>
                        <option value="">Select</option>
                        {CountryCode.map((country, index) => (
                          <option key={index} value={country.phonecode}>
                            {country.ios2} {emojiFromUPlus(country.emojiU)}
                            {" +"}
                            {country.phonecode}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Phone Number <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        onInput={(e) => {
                          const target = e.target as HTMLInputElement;
                          target.value = target.value
                            .replace(/\D/g, "")
                            .slice(0, 12);
                        }}
                      />
                    </div>
                  </div>

                  {/* Plan */}
                  {/* Password */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Password <span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={
                            passwordVisibility.password ? "text" : "password"
                          }
                          className="pass-input form-control"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                        />
                        <span
                          className={`ti toggle-passwords ${
                            passwordVisibility.password
                              ? "ti-eye"
                              : "ti-eye-off"
                          }`}
                          onClick={() =>
                            togglePasswordVisibility("password")
                          }></span>
                      </div>
                      <button
                        type="button"
                        className="btn btn-secondary mt-2"
                        onClick={generateRandomPassword}>
                        Generate Password
                      </button>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Address 1<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="address1"
                        value={formData.address1}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Address 2<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="address2"
                        value={formData.address2}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Country */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        Country <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="country"
                        value={formData.country}
                        onChange={handleCountryChange}>
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* State */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        State <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="state"
                        value={formData.state}
                        onChange={handleStateChange}
                        disabled={!formData.country}>
                        <option value="">Select State</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        City <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="city"
                        value={formData.city}
                        onChange={handleCityChange}
                        disabled={!formData.state}>
                        <option value="">Select City</option>
                        {cities.map((city) => (
                          <option key={city.id} value={city.id}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Pincode */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Pincode</label>
                      <input
                        type="text"
                        className="form-control"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={resetForm}
                  id="close-company-add-form">
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Add Company
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Company */}

      {/* <CrmsModal /> */}

      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />

      <EditCompany data={modalData ?? defaultCompanyData} />
    </>
  );
};

export default CompaniesList;
